import type { LearnerDemographicState } from './types';

export const initialLearnerDemographicState: LearnerDemographicState = {
  isOpen: false,

  numberOfLessonsClosed: 0,

  questions: []
};
